import React, { useState, useEffect } from 'react';
import ProspectTable from './ProspectTable';
import { getProspects, clearProspects } from '../../flux/actions/prospectActions';
import { Container, Row, Col, Button } from 'reactstrap';

import { connect } from 'react-redux';
import { ProspectContainer, IProspectReduxProps } from '../../types/interfaces';
import ProspectAdd from './ProspectAdd';
import LoadingPage from '../../pages/loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faUserCheck } from '@fortawesome/free-solid-svg-icons'
import { PRIVILEGE } from '../../types/privileges';

const ProspectContainerComponent = ({ 
  getProspects,
  clearProspects,
  prospect,
  auth
 }: ProspectContainer) => {

  const { prospects, loading } = prospect;
  const [tableData, setTableData] = useState(prospects);
  const [modal, setModal] = useState(false);

  useEffect(() => {
    getProspects();
  }, [getProspects, auth]);

  useEffect(() => {
    return () => {
      clearProspects();
    }
  }, []);

  useEffect(() => {
    return () => clearProspects()
  }, []);

  useEffect(() => {
    setTableData(prospects);
  }, [prospects]);

  return loading ? <LoadingPage/> : (
    <>
      <Container>
        <Row className="justify-content-between">
          <Col xs="12" md="8"><h2 className="title"><FontAwesomeIcon icon={faUserCheck} />&nbsp;&nbsp;Liste des Prospects</h2></Col>
          {!!auth?.user?.privileges?.includes(PRIVILEGE.ADD_CLIENT) && <Col xs="12" md="4" className="modalAddBtnCol">
            <Button
              className="btn btn-success linesConfirmationBtn"
              onClick={() => setModal(true)}
              ><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Ajouter un prospect</Button>
          </Col>}
        </Row>
      </Container>
      <ProspectTable linesData={tableData} />
      <ProspectAdd modal={modal} setModal={setModal} />
    </>
  );
};

const mapStateToProps = (state: IProspectReduxProps) => ({
  prospect: state.prospect,
  auth: state.auth
});

export default connect(mapStateToProps, { getProspects, clearProspects })(ProspectContainerComponent);
